import React from "react";
import CommonStaticSidebar from "./commonStaticSidebar";
import API from "../../api";
import moment from "moment";
import Article from "../Common/article";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {NavLink} from "react-router-dom";
import {images} from "../../constant";
import {BASE_URL} from "../../helper";
import {Helmet} from "react-helmet";
const api = new API();

class TagArchives extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            page : 1 ,
            blogs: [],
            default_store : this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
            scrollX: 0,
            scrolEnd: false,
            all_products: [],
            tagName : null
        };
        this.scrl = React.createRef();
    }

    //Slide click
    slide = (shift) => {
        this.scrl.current.scrollLeft += shift;
        this.setState({scrollX: scrollX + shift});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    scrollCheck = () => {
        this.setState({scrollX: this.scrl.current.scrollLeft});
        if (
            Math.floor(this.scrl.current.scrollWidth - this.scrl.current.scrollLeft) <=
            this.scrl.current.offsetWidth
        ) {
            this.setState({scrolEnd: true});
        } else {
            this.setState({scrolEnd: false});
        }
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        const tagId = this.props.location.state.id ;
        const tagName = this.props.location.state.name ;
        api.getFilterTagBlog(this.state.page,tagId).then(blogs => {
            this.setState({blogs: blogs.data,tagName : tagName });
        });
        api.getProducts({page: 1, restaurant_id : this.state.default_store}).then((products) => {
            this.setState({all_products: products.data.response.data});
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.state.id !== this.props.location.state.id ){
            const tagId = this.props.location.state.id ;
            const tagName = this.props.location.state.name ;
            api.getFilterTagBlog(this.state.page,tagId).then(blogs => {
                window.scrollTo(0, 0);
                this.setState({blogs: blogs.data , tagName : tagName});
            });
        }
        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.default_store){
            this.setState({default_store: this.props.cookies.get('selected_store') });
        }
    }

    render() {

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Tag Archives</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>
                    <div>
                        <div className="container-fluid about-content mt-3">
                            <div className="col-12">
                                <div className="row">
                                    <CommonStaticSidebar tag={this.state.tagName} />
                                    <div className="col-md-9 emp-form">
                                        <div className="row">
                                            {this.state.tagName &&
                                                 <h1>Tag Archives for "{this.state.tagName}"</h1>
                                            }
                                            {this.state.blogs.length > 0 ? this.state.blogs.map((blog,index)=>{
                                                const categories = blog?.["_embedded"]["wp:term"][0] ;
                                                const category_names = categories.map( (category,index) => <><a className="text-muted font-weight-medium" href="javascript:void(0)" onClick={()=>{
                                                    this.props.history.push({
                                                        pathname: '/blog-category-archives',
                                                        state : { id: category.id, name: category.name}
                                                    }, 'blog-category-archives')
                                                }}>{category.name}</a>{ index < (categories.length - 1) ?  " | " : "" } </>);
                                                const sort_description =  blog?.["acf"]["short_description"];
                                                return (
                                                    <>
                                                        <div key={index} className="col-md-12 p-0 mt-2">
                                                            <div className="col-12 main-section bg-white p-4 text-left">
                                                                <div className="col-12 mb-4 px-0">
                                                                    <small className="text-muted text-uppercase font-weight-medium font-12">{category_names}</small>
                                                                    <h1 className="my-2 art-head">{blog?.title?.rendered}</h1>
                                                                    <h6 className="text-muted text-capitalize">Posted on: {blog?.date ? moment(blog?.date).format('LL') : ""}</h6>
                                                                </div>
                                                                {sort_description &&
                                                                     <h6><p className="desc mb-0" dangerouslySetInnerHTML={{__html: sort_description}}/></h6>
                                                                }
                                                                <div className="col-12 text-center mb-2 px-0">
                                                                    <button type="button" className="btn btn-order py-2 px-4 mx-auto w-auto">
                                                                        <NavLink exact to={"/blog/" + blog.slug}><span className="text-white text-decoration-none">Continue Reading</span></NavLink>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }) :
                                                <div className="py-3 blank-banner mt-4">
                                                    <img src={images.order_food}/>
                                                    <h2 className="mt-3 mb-1">No record found</h2>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 article-related p-0">
                            <Article />
                        </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default withCookies(TagArchives);



